import { observable, action, makeObservable } from 'mobx';
import { InputType } from './types';

export class OAuthCredentialInput implements InputType {
  dataType: 'string';

  label: string;

  placeholder?: string;

  tag: string;

  @observable value!: string | null;

  @observable selectorValue!: Record<string, any> | null;

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputType) {
    if (dataType !== 'string') {
      throw Error(
        `Type mismatch. Type must be of "string", instead saw "${dataType}"`,
      );
    }
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null); // set initial value
  }

  @action
  onChange = (v: Record<string, any> | null) => {
    this.selectorValue = v;
    if (v) {
      switch (this.tag) {
        case 'openIDSub':
          this.value = v.sub;
          break;
        case 'openIDToken':
          this.value = v.token;
          break;
        default:
          break;
      }
    }
  };

  @action
  clearValue = () => {
    this.value = null;
    this.selectorValue = null;
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
